var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 134.106,
    height: 134.106,
    rx: 67.0529,
    fill: "#575E76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7191 87.0528C59.7191 85.9482 60.6145 85.0528 61.7191 85.0528H72.3857C73.4903 85.0528 74.3857 85.9482 74.3857 87.0528C74.3857 88.1573 73.4903 89.0528 72.3857 89.0528H61.7191C60.6145 89.0528 59.7191 88.1573 59.7191 87.0528ZM61.4969 93.7194C61.4969 92.6149 62.3923 91.7194 63.4969 91.7194H70.608C71.7125 91.7194 72.608 92.6149 72.608 93.7194C72.608 94.824 71.7125 95.7194 70.608 95.7194H63.4969C62.3923 95.7194 61.4969 94.824 61.4969 93.7194Z",
    fill: "#272A39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3857 56.9676C46.3857 46.555 55.8628 38.3861 67.0524 38.3861C78.2421 38.3861 87.7191 46.555 87.7191 56.9676L87.7191 56.9763C87.6935 62.8599 85.1628 68.7213 80.6672 72.9851L80.6616 72.9904L77.7175 75.7615C77.2931 76.161 77.0524 76.718 77.0524 77.3008C77.0524 80.1093 74.7756 82.3861 71.9671 82.3861H62.1377C59.3292 82.3861 57.0524 80.1093 57.0524 77.3008C57.0524 76.718 56.8118 76.161 56.3873 75.7616L53.4432 72.9904L53.4377 72.9851C48.942 68.7213 46.4114 62.8599 46.3858 56.9763L46.3857 56.9676ZM50.3857 56.9633C50.4077 61.7249 52.4663 66.5495 56.1875 70.0802C56.1884 70.0811 56.1893 70.082 56.1903 70.0829L59.1288 72.8488C60.3564 74.0041 61.0524 75.6151 61.0524 77.3008C61.0524 77.9002 61.5383 78.3861 62.1377 78.3861H71.9671C72.5665 78.3861 73.0524 77.9002 73.0524 77.3008C73.0524 75.6151 73.7484 74.0042 74.9759 72.8488C74.976 72.8488 74.9759 72.8488 74.9759 72.8488L77.9145 70.0829C77.9154 70.0821 77.9163 70.0812 77.9172 70.0804C81.6385 66.5495 83.6972 61.7248 83.7191 56.9631C83.7163 49.1847 76.4796 42.3861 67.0524 42.3861C57.6252 42.3861 50.3884 49.1849 50.3857 56.9633Z",
    fill: "#272A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/co2.46ae53a505729694632c3a17364547b8.svg";
export { ForwardRef as ReactComponent };